import React, { memo, useEffect } from "react";
import { Select, FormControl } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { useFetchFirstViewOptions } from "../../../hooks/useFetchFirstViewOptions";

type FirstViewSelectorProps = {
  control: any;
  errors: any;
  restaurantId: string | undefined;
  setValue: any;
}

export const FirstViewSelector: React.FC<FirstViewSelectorProps> = memo(({
                                                                             control,
                                                                             errors,
                                                                             restaurantId,
                                                                             setValue
                                                                         }) => {
    const { firstViewData, isLoading, error } = useFetchFirstViewOptions(restaurantId);

    // APIからデータが取得されたらフォームの値を設定
    useEffect(() => {
        if (firstViewData?.current_first_view?.id) {
            const valueToSet = String(firstViewData.current_first_view.id);
            setValue('restaurant.start_page', valueToSet);
        }
    }, [firstViewData, setValue]);

    // ローディング中は何も表示しない
    if (isLoading) return null;

    // エラーまたはデータが不正な場合は警告メッセージ付きで非表示
    if (error || !firstViewData || !Array.isArray(firstViewData.available_first_views) || firstViewData.available_first_views.length === 0) {
        return (
            <FormControl>
                <Select
                    placeholder="トップページ設定を読み込めませんでした"
                    disabled
                    bg="gray.100"
                    color="gray.500"
                />
            </FormControl>
        );
    }

    return (
        <FormControl>
            <Controller
                name='restaurant.start_page'
                control={control}
                render={({ field }) => {

                    return (
                        <Select
                            value={field.value || ""}
                            onChange={(e) => {
                                const value = e.target.value === "" ? null : e.target.value;
                                field.onChange(value);
                            }}
                        >
                            <option value="">ダッシュボード</option>
                            {firstViewData.available_first_views.map((firstView) => (
                                <option key={firstView.id} value={String(firstView.id)}>
                                    {firstView.name}
                                </option>
                            ))}
                        </Select>
                    );
                }}
            />
        </FormControl>
    );
});